import { render, staticRenderFns } from "./frontbody.vue?vue&type=template&id=8ec786ce&scoped=true&"
import script from "./frontbody.vue?vue&type=script&lang=js&"
export * from "./frontbody.vue?vue&type=script&lang=js&"
import style0 from "./frontbody.vue?vue&type=style&index=0&id=8ec786ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec786ce",
  null
  
)

export default component.exports